<template>
  <div class="candidate-stars-notation" :class="'text-' + starsColor">
    <QIcon v-for="(star, index) in integerNote" :key="index" name="icon-extra-star" />
    <QIcon v-if="shouldDisplayHalfStar" name="icon-extra-half-star" />
    <span v-if="notesAmount > 0">({{ notesAmount }})</span>
  </div>
</template>

<script>
  export default {
    props: {
      note: {
        type: [String, Number],
        default: 0,
      },
      notesAmount: {
        type: [String, Number],
        default: 0,
      },
      starsColor: {
        type: String,
        default: "accent-light",
      },
    },
    computed: {
      integerNote() {
        const note = Math.floor(this.note);
        return note > 0 ? note : 0;
      },
      shouldDisplayHalfStar() {
        return this.note - this.integerNote > 0;
      },
    },
  };
</script>

<style lang="scss">
  .candidate-stars-notation {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 1.3em;
      margin-right: -3px;
    }

    span {
      margin: 0 5px;
    }
  }
</style>
